import { render, staticRenderFns } from "./LanguagesModal.vue?vue&type=template&id=1c16ee27&scoped=true&"
import script from "./LanguagesModal.vue?vue&type=script&lang=ts&"
export * from "./LanguagesModal.vue?vue&type=script&lang=ts&"
import style0 from "./LanguagesModal.vue?vue&type=style&index=0&id=1c16ee27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c16ee27",
  null
  
)

export default component.exports